"use client"

import type * as React from "react"
import ChevronLeft from "@/assets/svg/chevron-left-black.svg"
import { routeHistory } from "@/lib/route-history"
import { cn } from "@/lib/utils"
import { useLocaleRouter, useRouterPush } from "@/lib/utils.client"

interface MobileHeaderProps {
	title: string
	onBack?: () => void
	className?: string
	showBackButton?: boolean
	rightContent?: React.ReactNode
}

export function MobileHeader({
	title,
	onBack,
	className,
	showBackButton = true,
	rightContent,
}: MobileHeaderProps) {
	const router = useLocaleRouter()
	const routerPush = useRouterPush()

	const handleBack = () => {
		if (onBack) {
			onBack()
		} else {
			const history = routeHistory.getHistory()
			if (history.length <= 1) {
				// 如果没有历史记录或只有当前页面，跳转到根目录
				routerPush("/")
			} else {
				router.back()
			}
		}
	}

	return (
		<header
			className={cn(
				"md:hidden  flex sticky top-0 items-center border-b bg-background p-3    z-20",
				className,
			)}
		>
			{/* Left side - Back button */}
			{showBackButton && (
				<ChevronLeft onClick={handleBack} className="size-5.5 text-[#111]" />
			)}

			{/* Center - Title (absolutely centered) */}
			<div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
				<h1 className="text-lg leading-none font-medium text-center truncate max-w-50 font-['DINPro']">
					{title}
				</h1>
			</div>

			{/* Right side - Optional content */}
			{rightContent && (
				<div className="flex items-center ml-auto z-10">{rightContent}</div>
			)}
		</header>
	)
}
